export interface IDocument {
    id: number;
    patientId: string;
    name: string;
    dateAdded: Date;
    size: number;
    filename: string;
    addedBy?: string;
  }

  export class Document {
    id: number;
    patientId: string;
    name: string;
    dateAdded: Date;
    size: number;
    filename: string;
    addedBy?: string;

    constructor(input: IDocument) {
        this.id = input.id;
        this.patientId = input.patientId;
        this.name = input.name;
        this.dateAdded = new Date(input.dateAdded);
        this.size = input.size;
        this.filename = input.filename;
        this.addedBy = input.addedBy;
    }
  }